.fileEntry {
    border: 1px solid #eceef2;
    padding: 12px 14px;
    margin: 4px;
    background-color: hsl(0 0% 96% / 1);
    font-size: 20px;
    font-family: Hanken Grotesk;
    font-weight: 600;
    border-radius: 10px;
    cursor: pointer;
}

.fileSummary {
    font-size: 14px;
    font-family: Hanken Grotesk;
    font-weight: 400;
    color: #555;
}

.seperator {
    width: 100%;
    height: 1px;
    background-color: #e3e6eb;
    margin: 0px 0;
    margin-bottom: 20px;
}

.cancelButton {
    background-color: white !important;
    border-color: #e3e6eb !important;
    color: black !important;
    font-size: 13px;
    font-family: 'Hanken Grotesk';
    width: 80px;
    border-radius: 10px !important;
    &:hover {
        background-color: #f5f5f5 !important;
    }
}

.confirmButton {
    width: 80px;
    background-color: #2075f4 !important;
    border-color: #2075f4 !important;
    color: white !important;
    font-size: 13px;
    font-family: 'Hanken Grotesk';
    border-radius: 10px !important;
    &:hover {
        background-color: #1864c6 !important;
        border-color: #1864c6 !important;
    }
}
